import React, { useContext, useEffect, useState } from "react";
import { useIdleTimer } from "react-idle-timer";
import { useNavigate } from "react-router-dom";
import { checkLoginStatus } from "../Utils/login";
import { SessionExists } from "./User/Session Exists/SesssionExists";
import { LanguageContext } from "../Context/changeLanguageProvider";
export function SessionTimeout () {
    const [TimeLeft, setTimeLeft]=useState(10)
    const navigate = useNavigate()
    const handleIdle = ()=>{
        navigate('/logout', {replace:true})
    }
    const {getRemainingTime}=useIdleTimer({
        timeout:10*1000,
        onIdle:handleIdle,
        stopOnIdle:true
    })
    useEffect(() => {
        setInterval(() => {
            console.log(TimeLeft)
            setTimeLeft(Math.floor(getRemainingTime()/1000));
        }, 1000);
    }, [getRemainingTime, TimeLeft]);
    return (<>
    {/* <div>
        {TimeLeft < 5 &&
        <h2>
          Your session will expire in {TimeLeft} seconds.
        </h2>
      }
    </div> */}
    </>)
}
export const FSessionTimeout = ({children, onIdlePath="/logout", timeout=10*60*1000}) =>{
    const [TimeLeft, setTimeLeft]=useState(10)
    const navigate = useNavigate()
    const handleIdle = ()=>{
        console.log('idle')
        navigate(`${onIdlePath}`)
    }
    const {getRemainingTime}=useIdleTimer({
        timeout:timeout,
        onIdle:handleIdle,
        stopOnIdle:false
    })
    useEffect(() => {
        setInterval(() => {
            setTimeLeft(Math.floor(getRemainingTime()/1000));
            return
        }, 1000);
    }, [getRemainingTime]);
    // useEffect(() => {
    //     console.log("TimeLeft:",TimeLeft)

    // }, [TimeLeft]);
    return children
}
export const KeepSessionAlive = ({children}) =>{
    const websiteCurrentLang = useContext(LanguageContext).language;
    const [dublicatedcontent, setDublicatedContent] = useState(
        websiteCurrentLang.content.DublicatedText
    );
    useEffect(() => {
        setDublicatedContent(websiteCurrentLang.content.DublicatedText);
    }, [websiteCurrentLang]);
    const [login_data, setLoginData] = useState(false)
    const navigate = useNavigate()
    const loginTimer = setInterval(() => {
        checkLoginStatus()
        .then(res=>{
            if (res.status==403){
                res.json()
                .then(login_data=>{
                    setLoginData(login_data)
                    // if(login_data?.webinar && !window?.location?.host.includes("/user/plan")) return navigate('/user/plan', {replace:true})
                })
                .catch(_=>{
                    return navigate('/login', {replace:true})
                })
            }
            else if(res.status!==200) return navigate('/login', {replace:true})
        })
        .catch(e=>console.log(e))
    }, 20*1000);
    return(login_data?<SessionExists login_data={login_data} device_text={dublicatedcontent?.device} login_time_text={dublicatedcontent?.login_time}  title={dublicatedcontent?.you_have_been_logged_out} message={dublicatedcontent?.you_have_opened_session} onclick={()=>{setLoginData(false);navigate('/login')}} button_message={dublicatedcontent?.dublicatedText3} />:children)
}